import HtmlEscaper from '@intercom/embercom-composer/lib/html-escaper';
import Constants from '@intercom/embercom-composer/lib/constants';
import cleanGoogleDocsHtml from '@intercom/embercom-composer/lib/html-cleanup/clean-google-docs-html';
import cleanWordDocsHtml from '@intercom/embercom-composer/lib/html-cleanup/clean-word-docs-html';
import cleanOnlineWordDocsHtml from '@intercom/embercom-composer/lib/html-cleanup/clean-online-word-docs-html';
import cleanTextEditHtml from '@intercom/embercom-composer/lib/html-cleanup/clean-text-edit-html';
import cleanGenericDocsHtml from '@intercom/embercom-composer/lib/html-cleanup/clean-generic-docs-html';
import cleanHtml from '@intercom/embercom-composer/lib/html-cleanup/clean-html';
import $ from 'jquery';
import Paragraph from '@intercom/embercom-composer/blocks/types/paragraph';
import Img from '@intercom/embercom-composer/blocks/types/image';
import OrderedList from '@intercom/embercom-composer/blocks/types/ordered-list';
import UnorderedList from '@intercom/embercom-composer/blocks/types/unordered-list';
import Heading from '@intercom/embercom-composer/blocks/types/heading';
import Subheading from '@intercom/embercom-composer/blocks/types/subheading';
import Code from '@intercom/embercom-composer/blocks/types/code';
import Button from '@intercom/embercom-composer/blocks/types/button';
import Video from '@intercom/embercom-composer/blocks/types/video';
import TwitterFollowButton from '@intercom/embercom-composer/blocks/types/twitter-follow-button';
import FacebookLikeButton from '@intercom/embercom-composer/blocks/types/facebook-like-button';
import Link from '@intercom/embercom-composer/blocks/types/link';
import createJQueryObjectFromString from '@intercom/embercom-composer/lib/create-jquery-object-from-string';
import intermoji from '@intercom/intermoji';
import { hasNativeEmojiSupport } from '@intercom/embercom-composer/lib/intermoji';
const BLOCK_NODES = ['DIV', 'P', 'UL', 'OL', 'H1', 'H2', 'IMG'];
const ALLOWED_INLINE_NODES = ['B', 'I', 'A', 'CODE'];
const DISALLOWED_INLINE_NODES = ['SPAN'];
let blockConfig;
export default function htmlToBlocks(html, config, uploadManager) {
  blockConfig = config;
  let blocks = [];
  let cleanedHtml = preprocess(html, config);
  // eslint-disable-next-line jquery-unsafe/no-html
  let $rootNode = $('<div>').html(cleanedHtml);
  convertElements($rootNode, 'strong', 'b');
  convertElements($rootNode, 'em', 'i');
  processBlockNode($rootNode[0], blocks, uploadManager);
  return blocks;
}
const preprocess = function (text, config) {
  text = cleanGoogleDocsHtml(text);
  text = cleanWordDocsHtml(text);
  text = cleanOnlineWordDocsHtml(text);
  text = cleanTextEditHtml(text);
  text = cleanGenericDocsHtml(text);
  if (config.get('allowEmoji')) {
    text = replacePastedEmojiImages(text);
  }
  text = cleanHtml(text);
  return text;
};
function convertElements($ctx, from, to) {
  $ctx.find(from).replaceWith(function () {
    // eslint-disable-next-line jquery-unsafe/no-html
    return $(`<${to}>`).html($(this).html());
  });
}
function processBlockNode(node, blocks, uploadManager) {
  let childNodes = node.childNodes;
  let childNode;
  for (let i = 0; i < childNodes.length; i++) {
    childNode = childNodes[i];
    if (childNode.nodeType === Node.TEXT_NODE) {
      i += processInlineNode(childNode, blocks);
    } else if (childNode.nodeType === Node.ELEMENT_NODE) {
      switch (childNode.nodeName) {
        case 'B':
        case 'I':
        case 'A':
        case 'SPAN':
          if (childNode.classList.contains('intercom-interblocks-link')) {
            processLinkCard(childNode, blocks);
          } else {
            i += processInlineNode(childNode, blocks);
          }
          break;
        case 'DIV':
        case 'P':
          processBlockNode(childNode, blocks, uploadManager);
          break;
        case 'UL':
          processList(childNode, blocks, 'unordered');
          break;
        case 'OL':
          processList(childNode, blocks, 'ordered');
          break;
        case 'H1':
          processHeading(childNode, blocks);
          break;
        case 'H2':
          processSubheading(childNode, blocks);
          break;
        case 'IMG':
          processImage(childNode, blocks, uploadManager);
          break;
        case 'PRE':
        case 'CODE':
          processCode(childNode, blocks);
          break;
        case 'IC-BLOCK':
          processICBlock(childNode, blocks);
          break;
        case 'IFRAME':
          processIframe(childNode, blocks);
          break;
        default:
          processBlockNode(childNode, blocks, uploadManager);
          break;
      }
    }
  }
  return blocks;
}
function processInlineNode(node, blocks) {
  if (isImageWithLink(node)) {
    processImageWithLink(node, blocks);
    return 0;
  }
  let nodeItr = node;
  let blockText = '';
  let align = 'left';
  if (node.parentNode && node.parentNode.getAttribute && node.parentNode.getAttribute('data-align')) {
    align = node.parentNode.getAttribute('data-align');
  }
  if (DISALLOWED_INLINE_NODES.includes(node.nodeName)) {
    blockText += extractInnerText(node);
  } else {
    blockText = extractOuterHTML(node);
  }
  let handledSiblings = 0;
  while (nodeItr = nodeItr.nextSibling) {
    if (BLOCK_NODES.includes(nodeItr.nodeName)) {
      // If we encounter a block node we're done here
      break;
    } else if (nodeItr.nodeName === 'BR') {
      if (!blockConfig.removeLineBreaks) {
        blockText += Constants.NEW_LINE;
      } else {
        blockText += ' ';
      }
      handledSiblings++;
    } else if (ALLOWED_INLINE_NODES.includes(nodeItr.nodeName)) {
      // If text node has an anchor block sibling with a single img block child, break
      if (nodeItr.nodeName === 'A' && nodeItr.childNodes.length === 1 && nodeItr.childNodes[0].nodeName === 'IMG') {
        break;
      }

      // Take the outerHTML of any valid inline nodes (b, i, a)
      blockText += nodeItr.outerHTML;
      handledSiblings++;
    } else if (nodeItr.nodeType === Node.TEXT_NODE) {
      // Grab text from text nodes
      blockText += html_encode(nodeItr.textContent);
      handledSiblings++;
    } else {
      // some sort of weird unhandled node, treat it as an inline node and grab its contents
      blockText += extractInnerText(nodeItr);
      handledSiblings++;
    }
  }
  let paragraph = Paragraph.create({
    config: blockConfig,
    text: blockText,
    align
  });
  paragraph.doInlineReplacements();
  blocks.pushObject(paragraph);
  return handledSiblings;
}
function processList(node, blocks, type) {
  let Klass = type === 'ordered' ? OrderedList : UnorderedList;
  let listItems = [];
  let childNodes = node.childNodes;
  let childNode;
  for (let i = 0; i < childNodes.length; i++) {
    childNode = childNodes[i];
    if (childNode.nodeType !== Node.TEXT_NODE) {
      listItems.push(extractInnerText(childNode));
    }
  }
  if (listItems.length > 0) {
    if (!blockConfig.allowOrderedList && Klass === OrderedList || !blockConfig.allowUnorderedList && Klass === UnorderedList) {
      let delimiter = blockConfig.removeLineBreaks ? ' ' : '\n';
      blocks.pushObject(Paragraph.create({
        config: blockConfig,
        text: listItems.join(delimiter)
      }));
      return;
    }
    blocks.pushObject(Klass.create({
      config: blockConfig,
      items: listItems
    }));
  }
}
function processHeading(node, blocks) {
  let text = extractInnerText(node);
  if (blockConfig.allowHeading) {
    let align = node.getAttribute('data-align');
    blocks.pushObject(Heading.create({
      config: blockConfig,
      text,
      align
    }));
  } else {
    blocks.pushObject(Paragraph.create({
      config: blockConfig,
      text
    }));
  }
}
function processSubheading(node, blocks) {
  let text = extractInnerText(node);
  if (blockConfig.allowSubheading) {
    let align = node.getAttribute('data-align');
    blocks.pushObject(Subheading.create({
      config: blockConfig,
      text,
      align
    }));
  } else {
    blocks.pushObject(Paragraph.create({
      config: blockConfig,
      text
    }));
  }
}
function processCode(node, blocks) {
  let text = extractInnerText(node);
  if (blockConfig.allowCode) {
    blocks.pushObject(Code.create({
      config: blockConfig,
      text
    }));
  } else {
    blocks.pushObject(Paragraph.create({
      config: blockConfig,
      text
    }));
  }
}
function extractInnerText(node) {
  let childNodes = node.childNodes;
  let childNode;
  let text = '';
  for (let i = 0; i < childNodes.length; i++) {
    childNode = childNodes[i];
    if (ALLOWED_INLINE_NODES.includes(childNode.nodeName)) {
      text += childNode.outerHTML;
    } else if (childNode.nodeType === Node.TEXT_NODE) {
      text += html_encode(childNode.textContent);
    } else {
      text += extractInnerText(childNode);
    }
  }
  return text;
}
function extractOuterHTML(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    return html_encode(node.textContent);
  }
  let attr = '';
  if (node.nodeName === 'A') {
    attr = `href="${node.getAttribute('href')}"`;
  }
  return `<${node.nodeName.toLowerCase()} ${attr}>${extractInnerText(node)}</${node.nodeName.toLowerCase()}>`;
}
function processImage(node, blocks, uploadManager) {
  // trustedlist: jpg, jpeg, png, gif
  let validImage = node.getAttribute('src').match(/^(?:http|data:image\/(?:jpg|jpeg|png|gif);base64.*)/);
  if (!validImage || !blockConfig.allowImage) {
    return;
  }
  let options = {};
  if (node.attributes) {
    options.url = node.getAttribute('src');
  }
  if (imageMaybePrivate(node)) {
    return;
  }
  options.config = blockConfig;
  let image = Img.create(options);
  image.uploadManager = uploadManager;
  blocks.pushObject(image);
}
function processImageWithLink(node, blocks) {
  if (!blockConfig.allowImage) {
    return;
  }
  let options = {};
  let link = node;
  if (link.attributes) {
    options.linkUrl = link.getAttribute('href');
  }
  let image = node.childNodes[0];
  if (image.attributes) {
    options.url = image.getAttribute('src');
  }
  if (imageMaybePrivate(image)) {
    return;
  }
  options.config = blockConfig;
  blocks.pushObject(Img.create(options));
}
function processIframe(node, blocks) {
  if (!blockConfig.allowVideo) {
    return;
  }
  let src = node.getAttribute('src');
  let id = src.match(Constants.YOUTUBE_IFRAME_EMBED_URL_REGEX);
  blocks.pushObject(Video.create({
    config: blockConfig,
    provider: 'youtube',
    id: id[1]
  }));
}
function processICBlock(node, blocks) {
  let type = node.getAttribute('data-type');
  switch (type) {
    case 'button':
      processICButton(node, blocks);
      break;
    case 'video':
      processICVideo(node, blocks);
      break;
    case 'image':
      processICImage(node, blocks);
      break;
    case 'twitterFollowButton':
      processTwitterFollowButton(node, blocks);
      break;
    case 'facebookLikeButton':
      processFacebookLikeButton(node, blocks);
      break;
    case 'link':
      processLinkCard(node, blocks);
      break;
  }
}
function processICButton(node, blocks) {
  if (!blockConfig.allowButton) {
    return;
  }
  let linkUrl = node.getAttribute('data-link-url');
  let text = node.getAttribute('data-text');
  let align = node.getAttribute('data-align');
  blocks.pushObject(Button.create({
    config: blockConfig,
    text,
    linkUrl,
    align
  }));
}
function processICVideo(node, blocks) {
  if (!blockConfig.allowVideo) {
    return;
  }
  let provider = node.getAttribute('data-provider');
  let id = node.getAttribute('data-escaped-video-id'); //TODO - does this need to be unescaped?
  blocks.pushObject(Video.create({
    config: blockConfig,
    provider,
    id
  }));
}
function processICImage(node, blocks) {
  if (!blockConfig.allowImage) {
    return;
  }
  let url = node.getAttribute('data-url');
  let linkUrl = node.getAttribute('data-link-url');
  let width = node.getAttribute('data-width');
  let height = node.getAttribute('data-height');
  let align = node.getAttribute('data-align');
  blocks.pushObject(Img.create({
    config: blockConfig,
    url,
    linkUrl,
    width,
    height,
    align
  }));
}
function processTwitterFollowButton(node, blocks) {
  if (!blockConfig.allowSocial) {
    return;
  }
  let username = node.getAttribute('data-username');
  blocks.pushObject(TwitterFollowButton.create({
    config: blockConfig,
    username
  }));
}
function processFacebookLikeButton(node, blocks) {
  if (!blockConfig.allowSocial) {
    return;
  }
  let url = node.getAttribute('data-url');
  blocks.pushObject(FacebookLikeButton.create({
    config: blockConfig,
    url
  }));
}
function processLinkCard(node, blocks) {
  let $card = $(node).find('.intercom-interblocks-link');
  let text = buildText($card);
  blocks.pushObject(Link.create({
    config: blockConfig,
    linkType: $card.data().linkType,
    title: $card.find('.intercom-interblocks-link-title').text(),
    description: $card.find('.intercom-interblocks-link-description').text(),
    url: $card.attr('href'),
    text,
    author: {
      name: $card.find('.intercom-interblocks-link-author-name').text(),
      avatar: $card.find('.intercom-interblocks-link-author-avatar-image').attr('src')
    }
  }));
}
function html_encode(text) {
  let nbpsRegex = new RegExp(Constants.NON_BREAKING_SPACE, 'g');
  return HtmlEscaper.escape(text).replace(nbpsRegex, ' ');
}
function isImageWithLink(node) {
  return node.nodeName === 'A' && node.childNodes && node.childNodes.length === 1 && node.childNodes[0].nodeName === 'IMG';
}
function replacePastedEmojiImages(text) {
  let fragment = createJQueryObjectFromString(text);
  fragment.find('img.ic_emoji_img').replaceWith(function () {
    let identifier = $(this).attr('alt');
    if (hasNativeEmojiSupport()) {
      return intermoji.unicodeFromIdentifier(identifier);
    } else {
      return `:${identifier}:`;
    }
  });
  return fragment.html();
}
function imageMaybePrivate(image) {
  let privateDomains = ['mail.google.com', 'docs.google.com'];
  let parser = document.createElement('a');
  parser.href = image.src;
  return privateDomains.includes(parser.host);
}
function buildText($card) {
  let anchor = document.createElement('a');
  anchor.innerText = $card.find('.intercom-interblocks-link-title').text();
  anchor.href = $card.attr('href');
  return anchor.outerHTML;
}